import { render, staticRenderFns } from "./shopDataC.vue?vue&type=template&id=05f92324&scoped=true&"
import script from "./shopDataC.vue?vue&type=script&lang=js&"
export * from "./shopDataC.vue?vue&type=script&lang=js&"
import style0 from "./shopDataC.vue?vue&type=style&index=0&id=05f92324&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f92324",
  null
  
)

export default component.exports